// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__9tUbC","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3TLBL","obliqueLine":"membershipbadge_obliqueLine__2lBqy"};